import ExchangeTaskEntry from './ExchangeTaskEntry';
import { ExchangeTaskGroup } from './ExchangeTask.shared';

interface ContractExchangeProps {
  campaignId: string;
  group: ExchangeTaskGroup;
}

const ContractExchange = ({ campaignId, group }: ContractExchangeProps) => (
  <ExchangeTaskEntry
    actionButtonId="completeContractExchangeBtn"
    campaignId={campaignId}
    group={group}
    panelKey="ContractExchangePanel"
    title="Agent Exchange"
  />
);

export default ContractExchange;
